import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DBDef_Action, DBDef_OrderGroup } from '@app/pathway-shared';
import { Button, ComponentSync, LL_V_L, TS_CollapsableContainerV2 } from '@nu-art/thunderstorm-frontend';
import { filterDuplicates, filterInstances, flatArray, sortArray } from '@nu-art/ts-common';
import { ModuleFE_Expression, ModuleFE_Variable, Preview_Variable } from '@app/hcs-frontend';
import './Renderer_PathwayVariables.scss';
import { ModuleFE_Action, ModuleFE_OrderGroup, ModuleFE_PathwayState, ModuleFE_PathwayTransition } from '../../../../../../_entity.js';
import { resolveResolutionFunctionVariables } from '../../../../../Component_ResolutionFunctionEditor/utils.js';
export const Renderer_PathwayVariables_Modules = [ModuleFE_Variable, ModuleFE_Expression, ModuleFE_Action, ModuleFE_OrderGroup];
export class Renderer_PathwayVariables extends ComponentSync {
    // ######################## Life Cycle ########################
    deriveStateFromProps(nextProps, state) {
        state.pathwayId = nextProps.pathwayId;
        state.stateId = nextProps.stateId;
        state.transitionId = nextProps.transitionId;
        if (!state.pathwayId) {
            state.states = [];
            state.transitions = [];
        }
        else {
            state.states = ModuleFE_PathwayState.cache.filter(s => s.pathwayIds.includes(nextProps.pathwayId));
            state.transitions = ModuleFE_PathwayTransition.cache.filter(t => t.pathwayIds.includes(nextProps.pathwayId));
        }
        //Filter down states and transitions if state id is passed
        if (state.stateId) {
            state.states = state.states.filter(s => s._id === nextProps.stateId);
            state.transitions = state.transitions.filter(t => t.sourceId === nextProps.stateId || t.targetId === nextProps.stateId);
        }
        //Filter down states and transitions if transition id is passed
        if (state.transitionId) {
            state.states = [];
            state.transitions = state.transitions.filter(t => t._id === nextProps.transitionId);
        }
        state.variables = this.getConnectedVariables(state.states, state.transitions);
        return state;
    }
    // ######################## Logic ########################
    getConnectedVariables(states, transitions) {
        const variableIds = filterDuplicates([
            ...this.getStateConnectedVariablesIds(states),
            ...this.getTransitionVariables(transitions),
            ...this.getResolutionFunctionVariables(transitions),
        ]);
        const variables = filterInstances(variableIds.map(id => ModuleFE_Variable.cache.unique(id)));
        return sortArray(variables, v => v._nameInLowercase);
    }
    getStateConnectedVariablesIds(states) {
        const orderIds = new Set();
        const variableIds = new Set();
        const preconditionPointers = filterDuplicates(states.map(state => state.preconditions.map(precondition => precondition.itemPointer)).flat(), pointer => pointer.id);
        //Gather order ids
        preconditionPointers.forEach(pointer => {
            switch (pointer.dbKey) {
                case DBDef_Action.dbKey:
                    orderIds.add(pointer.id);
                    break;
                case DBDef_OrderGroup.dbKey:
                    return ModuleFE_OrderGroup.cache.unique(pointer.id)?.__orderIds.forEach(id => orderIds.add(id));
            }
        });
        //Gather variable ids from orders
        for (const orderId of Array.from(orderIds)) {
            const order = ModuleFE_Action.cache.unique(orderId);
            if (ModuleFE_Action.is.order(order))
                variableIds.add(order.variableId);
        }
        return Array.from(variableIds);
    }
    ;
    getTransitionVariables(transitions) {
        const orderIds = new Set();
        const variableIds = new Set();
        const pointers = filterDuplicates(flatArray(transitions.map(transition => {
            return filterInstances([
                transition.testsIds,
                transition.treatmentsIds,
                transition.consultIds,
                transition.nurseIds,
            ]);
        })), pointer => pointer.id);
        //Gather Order Ids
        pointers.forEach(pointer => {
            switch (pointer.dbKey) {
                case DBDef_Action.dbKey:
                    orderIds.add(pointer.id);
                    break;
                case DBDef_OrderGroup.dbKey:
                    return ModuleFE_OrderGroup.cache.unique(pointer.id)?.__orderIds.forEach(id => orderIds.add(id));
            }
        });
        //Gather variable ids from orders
        for (const orderId of Array.from(orderIds)) {
            const order = ModuleFE_Action.cache.unique(orderId);
            if (ModuleFE_Action.is.order(order))
                variableIds.add(order.variableId);
        }
        return Array.from(variableIds);
    }
    getResolutionFunctionVariables(transitions) {
        const resolutionFunctions = filterInstances(transitions.map(t => ModuleFE_Expression.cache.unique(t.resolutionFunctionId)));
        return resolveResolutionFunctionVariables(resolutionFunctions);
    }
    // ######################## Render ########################
    render() {
        return _jsx(TS_CollapsableContainerV2, { className: 'pathway-variables', headerRenderer: this.render_Header, containerRenderer: this.render_Body, animated: true, forceUpdate: true });
    }
    render_Header = () => {
        return _jsxs(_Fragment, { children: [this.state.variables.length, " HCS Variables"] });
    };
    render_Body = () => {
        return _jsx(LL_V_L, { children: this.state.variables.map(variable => {
                return _jsx(Button, { variant: 'text', onClick: () => {
                        Preview_Variable.show(variable._id);
                    }, children: variable.name }, variable._id);
            }) });
    };
}
//# sourceMappingURL=Renderer_PathwayVariables.js.map